Wee.fn.make('print', {
	init: function() {
		this.$private.printListener();
	},
	unload: function() {
		$.events.off(null, '.print');
	}
}, {
	printListener: function() {
		$('ref:print').on('click.print', function() {
			$._win.print();
		});
	}
});